module.exports = __webpack_public_path__ + "assets/6a439fcf918d108f46884545771658fc.png";